import { render, staticRenderFns } from "./edit-dialog.pug?vue&type=template&id=0258be37&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./edit-dialog.scss?vue&type=style&index=0&id=0258be37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0258be37",
  null
  
)

export default component.exports